import { render } from "./EmailField.vue?vue&type=template&id=407b9d23"
import script from "./EmailField.vue?vue&type=script&lang=js"
export * from "./EmailField.vue?vue&type=script&lang=js"

import exportComponent from "/home/nginx/domains/panel.vip-mod.net/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"EmailField.vue"]])

export default __exports__